import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import { Message } from 'semantic-ui-react';
import _compact from 'lodash/compact';
import _isEmpty from 'lodash/isEmpty';
import _values from 'lodash/values';
import { ItemCartContext } from '../../CatalogItemCart.context';
import './ErrorMessages.css';
function ErrorMessages() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    formErrorMessages = _useState2[0],
    setFormErrorMessages = _useState2[1];
  var _useContext = useContext(ItemCartContext),
    apiErrorMessage = _useContext.apiErrorMessage,
    formErrors = _useContext.formErrors,
    touched = _useContext.touched;
  useEffect(function () {
    var presentFormErrors = _compact(_values(formErrors));
    if (!_isEmpty(presentFormErrors)) {
      setFormErrorMessages(presentFormErrors);
    } else {
      setFormErrorMessages([]);
    }
  }, [formErrors]);
  return /*#__PURE__*/React.createElement("div", {
    className: "error-messages-container"
  }, /*#__PURE__*/React.createElement(Message, {
    error: true,
    visible: !_isEmpty(formErrorMessages) && touched
  }, /*#__PURE__*/React.createElement(Message.List, null, formErrorMessages.map(function (message) {
    return /*#__PURE__*/React.createElement(Message.Item, {
      key: message
    }, message);
  }))), /*#__PURE__*/React.createElement(Message, {
    error: true,
    content: apiErrorMessage,
    visible: !_isEmpty(apiErrorMessage) && touched
  }));
}
export default ErrorMessages;